import { createComponentStore } from '../../utils/createComponentStore';

// Lowercase values match the backend v2 schema enum directly (no enum normalization needed).
export const TRIGGER_TYPE_TICKET_CREATED = 'ticket_created';
export const TRIGGER_TYPE_ANY_UPDATE = 'any_update';
export const TRIGGER_TYPE_STAGE_CHANGED = 'stage_changed';
export const TRIGGER_TYPE_SPECIFIC_FIELD = 'specific_field';

const keyAuto = () =>
  'board_ticket_' + (Math.floor(Math.random() * 90000000) + 10000).toString();

const initData = () => ({
  outputKey: keyAuto(),
  targetBoardId: null,
  triggerType: TRIGGER_TYPE_TICKET_CREATED,
  monitoredFieldKey: null,
  monitoredFieldLabel: null,
  includeWorkflowCreated: false,
});

const onLoadData = (rawData, component) => {
  const data = { ...initData(), ...rawData };
  if (!data.targetBoardId && component?.componentData?.targetBoardId) {
    data.targetBoardId = component.componentData.targetBoardId;
  }
  if (!data.triggerType) {
    data.triggerType = TRIGGER_TYPE_TICKET_CREATED;
  }
  return data;
};

const { createStore, getStore, defaultStore } = createComponentStore({
  type: 'trigger_on_board_ticket',
  endpoint: 'trigger_on_board_ticket',
  registryKey: 'trigger_on_board_ticket',
  initData,
  onLoadData,

  extraActions: (set, get) => ({
    setKey: (value) => set((s) => ({ data: { ...s.data, outputKey: value } })),
    setTargetBoardId: (targetBoardId) =>
      set((s) => ({ data: { ...s.data, targetBoardId } })),
    setTriggerType: (triggerType) => {
      const data = { ...get().data, triggerType };
      if (triggerType !== TRIGGER_TYPE_SPECIFIC_FIELD) {
        data.monitoredFieldKey = null;
        data.monitoredFieldLabel = null;
      }
      set({ data });
    },
    setMonitoredField: (fieldKey, fieldLabel) =>
      set((s) => ({
        data: { ...s.data, monitoredFieldKey: fieldKey, monitoredFieldLabel: fieldLabel },
      })),
    keyAuto,
  }),
});

export { createStore as createTriggerOnBoardTicketStore };
export const getTriggerOnBoardTicketStore = getStore;
export default defaultStore;
